var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-sorting-a",
    x1: "0%",
    x2: "126.883%",
    y1: "45.61%",
    y2: "56.29%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2673FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#96FF51"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(11 12)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 43,
    fill: "url(#card-sorting-a)",
    rx: 27,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB48",
    d: "M47.6402262,12.3906678 L53.5371103,30.1127143 C53.8250414,30.9780403 53.4911336,31.928562 52.7252842,32.4237066 L35.9518676,43.2682234 C35.0242803,43.8679364 33.7861589,43.6021417 33.1864459,42.6745545 C33.1064964,42.5508951 33.0404482,42.4187843 32.9895025,42.2806246 L26.1369044,23.697075 C25.7971903,22.7758048 26.1765025,21.7441855 27.0320958,21.2624134 L44.7612264,11.2793997 C45.7237013,10.7374441 46.9432832,11.0783425 47.4852387,12.0408174 C47.5479638,12.1522127 47.5998637,12.2693655 47.6402262,12.3906678 Z",
    opacity: 0.799,
    transform: "rotate(-139 39.787 27.357)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-107 24.103 19.134)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2673FF",
    d: "M35.8395462,23.00525 L3.47748794,26.7000233 C2.38004772,26.825318 1.38882526,26.0372383 1.26353061,24.9397981 C1.25935226,24.9032005 1.25618578,24.8664944 1.25403478,24.8297219 L-6.96331881e-13,3.39130435 L35.8395462,23.00525 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6969",
    d: "M38.2666088,0.176899152 C38.4034521,0.169446773 38.540699,0.176079399 38.6761859,0.196692477 C39.7681895,0.362830645 40.5187518,1.38275608 40.3526136,2.47475969 L37.4183538,21.7612509 L1.91846539e-13,2.26086957 L38.2666088,0.176899152 Z",
    opacity: 0.799
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSortingIcon);
export default __webpack_public_path__ + "static/media/card-sorting-icon.a424c5cef4eeb65bef3dfc9e730620bb.svg";
export { ForwardRef as ReactComponent };